<template>
  <page-view :title="$t('broadcast.title')" backLink="/dashboard" backText="Back to Dashboard" :key="$route.hash">
    <template v-slot:header-right v-if="[1, 6, 15, 16].includes(user.permission_id)">
      <Button @click="$router.push('/broadcast/schedule')" :disabled="disableNewBroadcast">{{ $t('library.newbroadcast') }}</Button>
    </template>
    <broadcast-list
      title="Live and upcoming broadcasts"
      titleLink="/broadcasts/upcoming"
      titleLinkText="Show all"
      status="upcoming"
      @numItems="iHaveBroadcasts($event, 'upcoming')"
    />
    <broadcast-list
      title="Last five completed broadcasts"
      titleLink="/broadcasts/past"
      titleLinkText="Show all"
      status="past"
      @numItems="iHaveBroadcasts($event, 'past')"
    />
    <broadcast-list
      title="Last five abandoned broadcasts"
      titleLink="/broadcasts/abandoned"
      titleLinkText="Show all"
      status="abandoned"
      @numItems="iHaveBroadcasts($event, 'abandoned')"
    />
    <template v-if="!upcoming && !past && !abandoned">
      <div class="d-f f-1 ai-c jc-c">
        <div class="ta-c page-placeholder-text">
          <h2>You don't have any broadcasts... yet</h2>
          <p>
            You can <a href="/broadcast/schedule" @click.prevent="$router.push('/broadcast/schedule')" class="link blue">create a new broadcast</a> to get started.
          </p>
        </div>
      </div>
    </template>
  </page-view>
</template>

<script>

import BroadcastList from '@/components/Broadcast/List.vue';

export default {
  components: {
    BroadcastList,
  },
  computed: {
    disableNewBroadcast() {
      const trialEnded = this.$store.getters['AccountManager/trialEnded'];
      const subscriptionEnded = this.$store.getters['AccountManager/subscriptionEnded'];

      if (trialEnded || subscriptionEnded) {
        return true;
      }

      return false;
    },
  },
  methods: {
    /**
     * Take a bool and a type and set that bool in the state
     * @param {Boolean} bool
     * @param {String} type
     */
    iHaveBroadcasts(bool, type) {
      this[type] = bool;
    },
  },
  data() {
    return {
      upcoming: true,
      past: true,
      abandoned: true,
    };
  },
};
</script>

<style lang="scss" scoped>
.broadcast-list {
  margin: 0 0 34px;
}
</style>
